export enum SiteEnv {
    Mrbilit = 'mrbilit',
    AirplaneTicket = 'airplaneticket',
}
